<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <b-row></b-row>
        </b-card-header>
        <b-col cols="12">
            <b-row class="d-flex align-items-center justify-content-md-between">
                <b-col cols="12" md="6" class="d-md-flex">
                    <base-input
                    label="Search"
                    v-model="searchQuery"
                    prepend-icon="fas fa-search"
                    placeholder="Search ID, Name, Date..."
                    >
                    </base-input>
                    <base-input label="Filter by Status" class="mx-4">
                        <el-select
                            v-model="status"
                            multiple
                            placeholder="Select Status"
                            disabled
                            >
                            <el-option
                                v-for="item in statusOption"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </base-input>
                </b-col>
                <b-col cols="12" md="3" >
                    <b-button class="float-right px-3 py-2 mb-2 mb-md-0" variant="outline-secondary" disabled>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#73839C" d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z"/></svg>
                        Filters
                    </b-button>
                </b-col>
            </b-row>
        </b-col>
        <div class="table-listings">
            <el-table 
                ref="multipleTable"
                v-loading="isTableLoading"
                :data="queriedData"
                style="width: 100%"
                @selection-change="selectionChange"
            >
                <el-table-column
                    type="selection"
                    width="55"
                ></el-table-column>

                <el-table-column
                    prop="invoice_no"
                    label="Invoice No."
                    min-width="150"
                    width="auto"
                ></el-table-column>

                <el-table-column
                    prop="customer_name"
                    label="Customer Name"
                    min-width="150"
                    width="auto"
                ></el-table-column>

                <el-table-column
                    prop="status"
                    label="Status"
                    min-width="150"
                    width="auto"
                ></el-table-column>

                <el-table-column
                    prop="total_amount"
                    label="Total Amount"
                    min-width="150"
                    width="auto"
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">RM {{ scope.row.total_amount| moneyFormatter }}</p>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="created_date"
                    label="Created Date"
                    min-width="150"
                    width="auto"
                ></el-table-column>

                <el-table-column
                    prop="invoice_date"
                    label="Invoice Date"
                    min-width="150"
                    width="auto"
                ></el-table-column>

                <el-table-column
                    prop="edit"
                    min-width="150"
                    width="auto"
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line text-primary" style="cursor: pointer;">Edit</p>
                    </template>
                </el-table-column>

                <el-table-column
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-dropdown trigger="click"  style="cursor: pointer">
                            <p class="el-dropdown-link mb-0 top-line">
                                <b-icon icon="three-dots-vertical"></b-icon>
                            </p>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>View Change Log</el-dropdown-item>
                                <el-dropdown-item class="text-danger">Delete</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
        >
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        
                    <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>
    
            </div>
            <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
                @change="paginationChanged($event)"
            >
            </base-pagination>
        </div>
    </b-card>
</template>
<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip, Select, Option, Button, Badge, Tag } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'

export default {
     mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Tooltip.name]: Tooltip,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Badge.name]: Badge,
        [Tag.name]: Tag,
    },
    data() {
        return {
            isTableLoading: false,
            propsToSearch:['name'],
            isFixed: true,
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            TableColumn:[{
                type: 'selection'
            }],
            tableData: [
                {
                    invoice_no: 1011,
                    customer_name: 'Ralph Edwards',
                    status: 'Sent',
                    total_amount: 259000,
                    created_date: '7 Aug 2022',
                    invoice_date: '23 Nov 2022'
                }
            ],
            status: '',
            statusOption: [{
                value: 'Excellent',
                label: 'Excellent'
            }, {
                value: 'Good',
                label: 'Good'
            }, {
                value: 'Fair',
                label: 'Fair'
            }, {
                value: 'Poor',
                label: 'Poor'
            }, {
                value: 'V.Poor',
                label: 'V.Poor'
            }, {
                value: 'Uncompleted',
                label: 'Uncompleted'
            }],
        }
    },
    methods: {
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        },
    }
}
</script>